<template>
    <div>
        <div class="wrapper">

            <div class="grid two" v-if="oop.length > 0">
 
                <div v-for="match in ddsMatches">
                    <score-card v-if="match.detail"
                                :match="match"
                                :flagPath="flagPath"
                                :key="match.id"
                                :detail="detail"
                                :data-id="match.id"
                                type="all"
                                :ticket="ticket"
                                mode="live">
                    </score-card>

                    <oop-match
                              v-if="!match.detail"
                              type="all"
                              :flagPath="flagPath"
                              :ticket="ticket"
                              :key="match.id"
                              :detail="detail"
                              :match="match"
                              :court="selectedCourt">
                   </oop-match>

                </div>
            </div>

            <div class="na" v-else>
                <h2 class="na__title" style="margin-bottom: 0">
                    No matches for this day
                </h2>
            </div>

        </div>

    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment-timezone'
// import OOPCourt from './OOPCourt'
import 'select2/dist/js/select2.full.js'
import queryString from 'query-string'
import MatchCard from './MatchCard'
import OOPMatch from './OOPMatch'

export default {
    components: {
        'score-card': MatchCard,
        'oop-match': OOPMatch
    },
    props: ['flag', 'detail', 'ticket', 'pretype', 'matches'],
    data() {
        return {
            oop: [],
            flagPath: this.flag + '/assets/dist/svg/flags/',
            type: this.pretype,
            selectedMatches: JSON.parse(this.matches),
            allMatches: [],
            ddsMatches: [],
            selectedCourt: '',
            today: ','
        }
    },
    created() {
        this.getFeed()
    },
    watch: {
        type() {
            this.getFeed()

        }
    },
    methods: {
        getFeed() {

            // Mixed OOP
            axios.get(`${window.feed_ip}/get/${window.tournament}/oop-mixed`).then(response => {

                this.oop = response.data;

                for (let day of this.oop) {
                    for (let court of day.courts) {
                        
                        this.allMatches.push(...court.matches)
                        
                    }
                }

                // switch to last day from feed after 8pm
                let todayDate = moment().tz('America/New_York').startOf('day').format('YYYY-MM-DD')
                let nowTime = moment().tz('America/New_York').format('HH')
                let usedDay = ''

                if (nowTime >= 20)
                    usedDay = response.data[response.data.length - 1].date
                else
                    usedDay = todayDate

                let today = this.oop.filter(function (day) {
                    return day.date == usedDay
                    // return day.date
                })

                if (!today[0])
                    return;

                today = today[0]

                if (today.length == '0') {

                    let totalDaysCount = response.data.length
                    this.today = response.data[totalDaysCount - 1]

                    for (let i = 0; i < response.data[totalDaysCount - 1].courts.length; i++) {
                        if (response.data[totalDaysCount - 1].courts[i].matches.length >= 1) {
                            this.selectedCourt = response.data[totalDaysCount - 1].courts[i].id
                            break;
                        }
                    }

                } else {
                    this.today = today

                    for (let i = 0; i < today.courts.length; i++) {
                        if (today.courts[i].matches.length >= 1) {
                            this.selectedCourt = today.courts[i].id
                            break;
                        }
                    }
                }

                // console.log(this.selectedMatches);
                this.allMatches.forEach(match => {
                    if (this.selectedMatches.some(selectedMatch => selectedMatch.match_id === match.id)) {
                        this.ddsMatches.push(match);
                    }
                });

                return this.ddsMatches

            }).catch(function (error) {
                console.log(error)
            })

        }
    }
}
</script>
